import React from 'react';
import styled from '@emotion/styled';

import {
  ModalHeader,
  VerticalFlexContainer,
  ScrollablePaddedModalBody,
} from './ModalContainers/ModalContainers';

import HandOffLink from '../../../utils/urls/HandOffLink';
import colors from '../../../styling/colors';

const ScrollablePaddedModalBodyExtend = styled(ScrollablePaddedModalBody)`
  display: flex;
  flex-direction: column;
`;

const Heading = styled.h4`
  font-size: 0.875rem;
  margin: 1rem 0 0.5rem;
`;

const Paragraph = styled.p`
  font-size: 0.875rem;
  line-height: 1.5rem;
  margin: 0;

  p + & {
    margin-top: 1rem;
  }
`;

const StyledLink = styled(HandOffLink)`
  color: ${colors('gatsby')};
  text-decoration: underline;
`;

/**
 * CoinInfo
 *
 * @description
 * Shows the coin info modal
 *
 * @property {function} onClose - function to close the modal
 */
const CoinInfo = ({ isMobile }) => (
  <VerticalFlexContainer>
    <ModalHeader isMobile={isMobile}>Coin Information</ModalHeader>
    <ScrollablePaddedModalBodyExtend isMobile={isMobile}>
      <Heading>What is a coin?</Heading>
      <Paragraph>
        Our digital Cards are sent with credits called Coins. Your first 25
        Coins are free when you sign up for a Paperless Post account. The
        "starting at" number of Coins displayed next to each design is the
        starting price of the Card. The final price will include any additional,
        optional Premium elements (including the envelope, liner, backdrop,
        stamp, or reply card).
      </Paragraph>

      <Heading>How do I lower the cost of my card?</Heading>
      <Paragraph>
        You can remove any optional premium element from your final design. To
        do so, follow the instructions for each from{' '}
        <StyledLink
          identifier="free sending"
          target="_blank"
          href="https://paperlesspost.zendesk.com/hc/en-us/articles/206522773-I-thought-my-card-was-free-Why-am-I-being-asked-to-buy-Coins-"
        >
          here
        </StyledLink>
        .
      </Paragraph>

      <Heading>How much will it cost?</Heading>
      <Paragraph>
        To determine the total cost, take your design’s number of "Coins per
        recipient" and multiply it by the number of guests you plan to invite.
        For example, if a design requires 5 Coins per recipient and you are
        inviting 40 guests, you will need 200 Coins to send your invitation. Our
        200 Coin package is $30. You can find all of our Coin packages and
        pricing{' '}
        <StyledLink identifier="buy coins" target="_blank" href="/buy_coins">
          here
        </StyledLink>
        .
      </Paragraph>

      <Paragraph>
        We’re here to help! If you have any additional questions, please{' '}
        <StyledLink identifier="contact us" target="_blank" href="/contact">
          contact us
        </StyledLink>
        .
      </Paragraph>
    </ScrollablePaddedModalBodyExtend>
  </VerticalFlexContainer>
);

export default React.memo(CoinInfo);
